import React, { useContext, useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import { Button, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../App";
import Offcanvasbar from "./Offcanvasbar";
import Logo from "../../Assets/images/logoh.png";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";

function Header({ isShop }) {
  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [messageShow, setMessageShow] = useState(false);
  const handleMessageClose = () => setMessageShow(false);
  const handleMessageShow = () => setMessageShow(true);
  const dispatch = useDispatch();
  const toast = useRef(null);
  const [currentDateTime, setCurrentDateTime] = useState(
    getFormattedDateTime()
  );

  const handleLogout = async () => {
    Swal.fire({
      show: true,
      title: `خروج از پنل ${isShop? 'فروشگاه': "مدیریتی"}`,
      text: ` آیا می خواهید از پنل ${isShop? 'فروشگاه ': "مدیریتی"}  خارج شوید؟`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      cancelButtonColor: "#d33",
      icon: "success",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await accept();
      }
    });
  };
  const accept = () => navigate("/");

  function getFormattedDateTime() {
    const now = new Date();
    const daysOfWeek = [
      "یکشنبه",
      "دوشنبه",
      "سه شنبه",
      "چهارشنبه",
      "پنجشنبه",
      "جمعه",
      "شنبه",
    ];

    const dayOfWeek = daysOfWeek[now.getDay()];
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");

    return `${dayOfWeek} ${hours}:${minutes}`;
  }

  // Function to update the current date and time
  function updateCurrentDateTime() {
    setCurrentDateTime(getFormattedDateTime());
  }

  // Set up the effect to update the date and time every second
  useEffect(() => {
    const intervalId = setInterval(updateCurrentDateTime, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Navbar className="header-cpanel" fixed="top" dir="ltr">
      <Container fluid className="">
        {/*<Navbar.Toggle aria-controls="basic-navbar-nav"/>*/}
        <Offcanvasbar
          isShop={isShop}
          show={show}
          handleClose={handleClose}
          setShow={setShow}
          theme={theme}
        />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto d-flex justify-content-between align-items-center cpanel-nav">
            <div
              className="d-flex align-items-center cursor-pointer "
              onClick={handleShow}
            >
              <FontAwesomeIcon
                icon={"bars"}
                className="mx-2 color-gray fs-5 d-flex d-md-none"
              />
            </div>
            <Link to={`${isShop ? "/shoppanel" : "dashboard"}`}>
              <img src={Logo} className="clogo d-flex  d-md-none" />
            </Link>
            <div
              className="d-flex d-md-none justify-content-between align-items-center cursor-pointer"
              onClick={handleLogout}
            >
              <FontAwesomeIcon icon={"sign-out"} className="color-gray fs-5" />
            </div>
          </Nav>
          <Link to="/cpanel" className="px-1  ">
            <img src={Logo} className="clogo d-none d-md-flex  " alt="" />
          </Link>
        </Navbar.Collapse>
        <div
          className="d-none d-md-flex justify-content-between align-items-center cursor-pointer"
          onClick={handleLogout}
        >
          <div>
            <FontAwesomeIcon icon={"sign-out"} className="color-gray fs-5" />
          </div>
        </div>
      </Container>
    </Navbar>
  );
}
export default Header;
